<template>
    <div class="window bg">
        <div class="container">
            <menu-option v-bind:is-white="showStart" v-on:backIsClick="goBack"></menu-option>
            <Loading class="progress" v-if="recordStart"  v-on:onRecordDone="handleRecordDone" is-long="true"></Loading>
            <!--background black-->
            <transition :css="false" @enter="enterAnimation" appear>
                <counter v-if="counterStart" v-on:onRecord="handleRecordStart"></counter>

            </transition>
            <!-- end background black-->

            <!--<menu-option v-bind:is-white="showStart" v-on:backIsClick="goBack"></menu-option>-->
            <div class="img-container" v-if="showCharacter">

                    <img v-bind:src="getCharacter.fullImage" class="img-container_img">
                <transition :css="false" @enter="enterAnimation" appear>

                    <character-talk v-bind:center-text="true" class="margin-bottom dialog-size" v-bind:text="text"
                                    v-bind:show-next="false" v-bind:is-blue="false"  v-bind:show-name="false"></character-talk>
                </transition>

            </div>
            <button v-if="showStop" class="btn-stop" @click="handleRecordDone">Stop</button>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import MenuOption from "../components/MenuOption";
    import Counter from "../components/Counter";
    import CharacterTalk from "../components/CharacterTalk";
    import RecordMixin from "../mixins/RecordMixin";
    import Loading from "../components/Loading";
    import anime from 'animejs';


    export default {
        name: "FreeTalkStart",
        components: {
            Loading,
            MenuOption,
            Counter,
            CharacterTalk
        },
        mixins: [RecordMixin],
        computed: {
            ...mapGetters(["getCharacter", "getPracticeText"])
        },
        methods: {
            ...mapMutations(['setMode']),
            start() {
                this.counterStart = true;
                this.showCharacter = false;
                this.showStart = false;
            },
            handleRecordDone() {
                this.recordDone();
                this.setMode('free')
                this.$router.push('/result');
            },
            handleRecordStart() {
                this.record();
                this.showCharacter = true;
                this.counterStart = false;
                this.recordStart = true;
            },
            goBack() {
                if (this.isRecording) {
                    this.cancelRecord();
                }
                this.$router.push("/menu");
            },
            enterAnimation(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            }
        },
        data() {
            return {
                recordStart: false,
                counterStart: false,
                showCharacter: true,
                showStart: true,
                showStop: false,
                text: '<ruby>自由<rt>じゆう</rt></ruby>に<ruby>話<rt>はな</rt></ruby>してくださいね！'
            };
        },
        mounted() {
            this.start();
            setTimeout(()=>{
               this.showStop = true;
            } ,10000)
        }
    };
</script>

<style scoped>
    .dialog-size{
        width: 324px !important;
        height: 140px !important;
    }
</style>
